import React from 'react';

const TableRow = ({valid, rowKey, showValidation, children}) => {
  const shouldValidate = () => {
    return( typeof valid == 'boolean' )
  }

  const icon = () => {
    return(
      shouldValidate() &&
      <i
        className={`fa fa-${valid ? 'check-circle' : 'times-circle'} fa-2x`}
        style={{color: valid ? '#3c763d' : '#a94442'}}>
      </i>
    )
  }

  const formGroupClass = () => {
    return(
      shouldValidate()
      ? `form-group has-feedback has-${valid ? 'success' : 'error'}`
      : `form-group`
    )
  }

  return (
    <tr className={formGroupClass()} key={rowKey}>
      {children}
      {
        showValidation &&
        <td>
          {icon()}
        </td>
      }
    </tr>
  );
};

export default TableRow;
